<template>
  <div class="pd-Cart_Price">
    <span v-if="variant">
      <span v-if="variant.price_crossed">
        <!-- SALE 119,99€ -->
        <span class="sw-PriceTag_PriceSale"
          >SALE {{ price | toCurrency }} {{ currency_symbol }}</span
        >
        <!-- ~~ 219,99€ ~~ -->
        <span class="sw-PriceTag_PriceCrossed">
          {{ variant.price_crossed | toCurrency }} {{ currency_symbol }}
        </span>
      </span>
      <span v-else>
        <!-- ** 99,99€ ** -->
        <span class="sw-PriceTag_PriceBold">{{ price | toCurrency }} {{ currency_symbol }}</span>
      </span>
      <span
        v-if="variant.base_amount_product && variant.base_unit"
        class="pd-Cart_BaseAmountProduct"
      >
        {{ for_text }} {{ variant.base_amount_product }} {{ baseUnit(variant) }}
      </span>
      <span
        v-if="variant.price_per_unit > 0 && variant.base_amount !== variant.base_amount_product"
      >
        <span class="pd-Cart_PricePerUnit">
          <!-- eslint-disable -->
          ({{ variant.price_per_unit | toCurrency }} {{ currency_symbol }} / {{ variant.base_amount }} {{ baseUnit(variant) }})
          <!-- eslint-enable -->
        </span>
      </span>
    </span>
    <span v-else>
      <!-- ab 95,90€ -->
      <span class="pd-Cart_PriceTag">
        <span v-if="differentPrices">{{ from_text }} </span
        ><span>{{ price | toCurrency }} {{ currency_symbol }}</span>
      </span>
      <span
        v-if="cheapestVariant && cheapestVariant.base_amount_product && cheapestVariant.base_unit"
      >
        <span class="pd-Cart_BaseAmountProduct">
          {{ for_text }} {{ cheapestVariant.base_amount_product }} {{ baseUnit(cheapestVariant) }}
        </span>
        <span class="pd-Cart_PricePerUnit">
          <!-- eslint-disable -->
          ({{ cheapestVariant.price_per_unit | toCurrency }} {{ currency_symbol }} / {{ cheapestVariant.base_amount }} {{ baseUnit(cheapestVariant) }})
          <!-- eslint-enable -->
        </span>
      </span>
    </span>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import compareProperties from "../mixins/compareProperties";

export default {
  name: "VariantPrice",
  filters: {
    toCurrency(value) {
      return `${value.toFixed(2)}`.replace(".", ",");
    },
  },
  mixins: [compareProperties],
  props: {
    for_text: {
      required: true,
      type: String,
    },
    from_text: {
      required: true,
      type: String,
    },
    currency_symbol: {
      required: true,
      type: String,
    },
    translations: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters({
      variantId: "variantPicker/chosenVariant",
      allVariants: "variantPicker/allProductVariants",
      selectedProperties: "variantPicker/selectedProperties",
    }),
    differentPrices() {
      return new Set(this.allVariants.map(v => v.price)).size > 1;
    },
    variant() {
      return this.allVariants.find(variant => variant.id === this.variantId);
    },
    cheapestVariant() {
      return this.allVariants.find(v => v.price === this.price);
    },
    price() {
      const selectedProperties = this.allVariants.filter(variant => {
        return variant.properties.some(property => {
          return this.selectedProperties.some(selected =>
            this.compareProperties(selected, property)
          );
        });
      });

      if (this.variant) return this.variant.price;

      if (selectedProperties.length) {
        const possibleVariants = this.allVariants.filter(variant =>
          variant.properties
            .map(variantProperty =>
              this.selectedProperties
                .map(selectedProperty => this.compareProperties(variantProperty, selectedProperty))
                .some(cond => cond === true)
            )
            .some(cond => cond === true)
        );
        return Math.min(...possibleVariants.map(variant => variant.price));
      }

      return Math.min(...this.allVariants.map(variant => variant.price));
    },
  },
  methods: {
    baseUnit(variant) {
      return this.translations[variant.base_unit] || variant.base_unit;
    },
  },
};
</script>

<style lang="scss">
.sw-PriceTag_PriceBold {
  font-weight: bold !important;
  color: black;
}
</style>
